import { useEffect } from "react";
import AOS from "aos";
import axios from "axios";
import CryptoJS from "crypto-js";

import Step from "./components/Step";
import { useAIQuoteSteps } from "./hooks/useAIQuoteSteps";
import { getStepsConfig } from "./config/StepConfig";

import "./style.css";
import { config } from "./config";
import { encrypt } from "./utils/encrypt";
import { NavLink, useLocation } from "react-router-dom";

function useQuery() {
  return new URLSearchParams(window.location.search);
}

const ENCRYPTION_KEY = "lUBYNEzVG5wnWQwnGh1SDEcQMEmE7";

function decrypt(encryptedText) {
  const bytes = CryptoJS.AES.decrypt(encryptedText, ENCRYPTION_KEY);
  return bytes.toString(CryptoJS.enc.Utf8);
}

export default function AIQuote() {
  const {
    currentStep,
    selectedType,
    userData,
    setCurrentStep,
    setSelectedType,
    setUserData,
  } = useAIQuoteSteps();

  const goNext = () => {
    setCurrentStep(selectedType === "design" ? 3 : currentStep + 1);
  };

  const steps = getStepsConfig({
    goNext,
    userData,
    setUserData,
    selectedType,
    setSelectedType,
  }).filter((step) => !step.skip);

  const query = useQuery();

  useEffect(() => {
    const data = query.get("data");
    const supportOptions = query.get("supportOptions");

    const confirmCustomer = async () => {
      try {
        if (
          window.orderPageLoadConfig &&
          window.orderPageLoadConfig.information &&
          window.orderPageLoadConfig.information.customerID
        ) {
          const response = await axios.post(
            `${config.BASE_API_URL}/api/v1/customers/confirm`,
            {
              customerID: window.orderPageLoadConfig.information.customerID,
            }
          );

          setCurrentStep(3);

          setUserData((prev) => ({
            ...prev,
            id: response.data.id,
            name: window.orderPageLoadConfig.information.name,
            email: window.orderPageLoadConfig.information.email,
            phone: window.orderPageLoadConfig.information.phone,
            urls: window.orderPageLoadConfig.information.userSelected,
            originalFiles: window.orderPageLoadConfig.attachments.amazon,
            AIResponse: [response.data.total],
            backButton: true,
          }));
        }
      } catch (error) {
        console.error("Error confirming customer:", error);
      }
    };

    if (
      window.orderPageLoadConfig &&
      window.orderPageLoadConfig.information &&
      window.orderPageLoadConfig.information.customerID
    ) {
      confirmCustomer();
    }

    const confirmSupportOptions = async () => {
      try {
        const decryptedData = decrypt(decodeURIComponent(data));
        const parsedData = JSON.parse(decryptedData);
        parsedData.supportOptions = decodeURIComponent(supportOptions);

        const customerID = encrypt(String(parsedData.clientInformation.id));

        const response = await axios.post(
          `${config.BASE_API_URL}/api/v1/customers/info`,
          {
            customerID: customerID,
          }
        );

        setCurrentStep(3);

        setUserData((prev) => ({
          ...prev,
          id: response.data.id,
          name: response.data.name,
          email: response.data.email,
          phone: response.data.phone,
          urls: response.data?.userData?.urls || [],
          originalFiles: response.data?.originalFiles || [],
          AIResponse: [
            {
              elementor: response.data.total.elementor,
              frontend: response.data.total.frontend,
              wordpress: response.data.total.wordpress,
            },
          ],
          supportOptions: parsedData?.supportOptions,
        }));

        const newUrl = window.location.origin + window.location.pathname;
        window.history.replaceState({}, document.title, newUrl);
      } catch (error) {
        console.error("Error confirming support options:", error);
      }
    };

    if (data && supportOptions) {
      confirmSupportOptions();
    }
  }, []);

  useEffect(() => {
    AOS.init({
      once: true,
      duration: 700,
      easing: "ease-out-cubic",
    });
  }, []);

  return (
    <>
      <div className="app-columns-wrapper">
        <div className="app-container">
          {steps.map((step, index) => (
            <Step
              key={step.step}
              step={step}
              index={index}
              currentStep={currentStep}
            />
          ))}
        </div>
      </div>
    </>
  );
}
